import type { Component } from 'solid-js';
import { Index, createSignal, createMemo } from 'solid-js';
import './SurveySlider.css';

interface Props {
  plugin_question_title?: string;
  range?: [number, number];
  onChange?: (value: number) => void;
}

export const SurveySlider: Component<Props> = (props) => {
  const title = props.plugin_question_title ?? 'Being organized is important to me';
  const range = ()=>props.range ?? [1, 100];
  const rangeMid = (range()[1]+range()[0])/2
  const min = range()[0];
  const max = range()[1];
  const initialValue = Math.max(min, Math.min(max, rangeMid));
  const [value, setValue] = createSignal(initialValue);

  const updateValue = (newVal: number) => {
    const clamped = Math.round(Math.max(min, Math.min(max, newVal)));
    setValue(clamped);
    props.onChange?.(clamped);
  };

  const percent = createMemo(() => {
    const val = value();
    return Math.ceil(((val - min) / (max - min)) * 100);
  });

  const [trackEl, setTrackEl] = createSignal<HTMLDivElement>();

  // const onTrackClick = (e: MouseEvent) => {
  //   const rect = (e.currentTarget as HTMLDivElement).getBoundingClientRect();
  //   const p = ((e.clientX - rect.left) / rect.width) * 100;
  //   const val = min + (Math.max(0, Math.min(100, p)) / 100) * (max - min);
  //   console.log('track')
  //   updateValue(val);
  // };

  const onBarClick = (idx: number) => {
    const val = min + (idx / 100) * (max - min);
    updateValue(val);
  };

  const onHandleMouseDown = (e: MouseEvent) => {

    e.preventDefault();
    const onMouseMove = (me: MouseEvent) => {
      const rect = trackEl()?.getBoundingClientRect();
      if (!rect) return;
      const p = ((me.clientX - rect.left) / rect.width) * 100;
      const val = Math.floor(min + (Math.max(0, Math.min(100, p)) / 100) * (max - min));
      updateValue(val);
    };
    onMouseMove(e)
    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  return (
    <div class="plugin_question">
      <div class="plugin_question_title">{title}</div>
      <div class="mindtime-slider">
        <div class="slider-container">
          <div class="slider-value"
            onMouseDown={onHandleMouseDown}
            style={{ left: `${percent()}%` }}>
            {Math.floor(value())}
          </div>
          <div class="slider-track" ref={setTrackEl}>
            <Index each={new Array(100)}>
              {(_item, idx) => (
                <div
                  id={`${idx+1}_bar`}
                  class="bar"
                  classList={{ filled: idx <= percent() }}
                  onMouseDown={onHandleMouseDown}
                  onClick={(e) => {
                    onBarClick(idx);
                    e.stopPropagation();
                  }}
                />
              )}
            </Index>
          </div>
          <div
            class="slider-handle"
            style={{ left: `${percent()}%` }}
            onMouseDown={onHandleMouseDown}
          />
          <div class="slider-min-max" >
            <div class="end-texts">
              <span>{min}</span>
              <span>{max}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
